import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  changeOrder,
  changePage,
  changePerPage,
  loadSimilarData,
} from './actions';
import { selectSimilar } from './selectors';
import { makeSelectPatterns } from '../HomePage/selectors';
import { makeSelectCurrentLanguage } from '../Language/selectors';
import withI18next from '~/../hocs/_withI18next';
import Breadcrumb from '~/components/Breadcrumb';
import Gallery from '~/components/Gallery';
import GalleryIllust from '~/components/Gallery/GalleryIllust';
import Link from '~/components/I18nLink';
import I18nRouter from '~/components/I18nRouter';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import Pagination from '~/components/Pagination';
import Config, { keyConfig } from '~/config';
import { urls } from '~/utils';

@withI18next()
class SimilarPage extends React.Component {
  onChangeOrder = (value, currentLang) => {
    this.props.changeOrder(value);

    const query = Object.assign({}, this.props.similarPage.query, {
      order_by: value,
    });

    const { data_id, ...beQueryStrings } = query;

    const path = urls.convertToQueryStrings(beQueryStrings);

    this.props.loadSimilarData(query);

    I18nRouter.push(
      '/search-result/similar',
      `/search-result/similar/${data_id}?${path}`,
      { shallow: true },
    );
  };

  onChangePerPage = (value, currentLang) => {
    this.props.changePerPage(value);

    const query = Object.assign({}, this.props.similarPage.query, {
      per_page: value,
    });

    const { data_id, ...beQueryStrings } = query;

    const path = urls.convertToQueryStrings(beQueryStrings);

    this.props.loadSimilarData(query);

    I18nRouter.push('/similar', `/search-result/similar/${data_id}?${path}`, {
      shallow: true,
    });
  };

  onChangePage = (page) => {
    this.props.changePage(page);
  };

  onNextLink() {
    let currentPage = this.props.similarPage.page;
    if (currentPage >= this.props.similarPage.totalPage) {
      return;
    }
    currentPage++;

    const query = { ...this.props.similarPage.query, page: currentPage };

    const { data_id, ...beQueryStrings } = query;

    const path = urls.convertToQueryStrings(beQueryStrings);

    return `search-result/similar/${data_id}?${path}`;
  }

  render() {
    const {
      error,
      totalPage,
      collection,
      data,
      loading,
      query,
      page,
      dataType,
      hasNext,
      totalItem,
    } = this.props.similarPage;
    const { currentLanguage, t, patterns } = this.props;
    const {
      order_by: orderBy,
      per_page: perPage,
      same_creator: sameCreator,
    } = query;
    console.log('currentLanguagecurrentLanguage', query);

    const imageSize = Config.getFixedSizeByDataType(dataType);

    const keywords = Config.getTitleByLanguage(
      data ? data.title : {},
      currentLanguage,
    );

    return (
      <div className="search-result-page">
        <div className="container-fluid">
          <div className="breadcrumb-wrapper">
            <div className="col-sm-8 breadcrumb-left">
              <Breadcrumb
                title={
                  sameCreator
                    ? t('ill_similar_same_creator')
                    : t(keyConfig.get('title_similar_detail'), {
                        text: keywords,
                      })
                }
              />
            </div>
            <div className="col-sm-4 pagination-right">
              {/* <Filter>
                <div className="filter-item" style={{ padding: '10px 15px' }}>
                  <div className="filter-title">{t('sort_by_page')}</div>
                  <div
                    className="filter-content"
                    style={{ flexDirection: 'column' }}
                  >
                    <Radio
                      style={{ paddingBottom: 10 }}
                      groupName="orderBy"
                      onChange={() =>
                        this.onChangeOrder('popular', currentLanguage)
                      }
                      checked={orderBy === 'popular'}
                      label={t('radio_popular')}
                    />
                    <Radio
                      groupName="orderBy"
                      onChange={() =>
                        this.onChangeOrder('newest', currentLanguage)
                      }
                      checked={orderBy === 'newest'}
                      label={t('radio_lastest')}
                    />
                  </div>
                </div>
                <div className="filter-item" style={{ padding: '10px 15px' }}>
                  <div className="filter-title">{t('filter_per_page')}</div>
                  <div className="filter-content">
                    <Radio
                      style={{ paddingRight: 15 }}
                      onChange={() =>
                        this.onChangePerPage('100', currentLanguage)
                      }
                      checked={+perPage === 100}
                      groupName="perPage"
                      label="100"
                    />
                    <Radio
                      style={{ paddingRight: 15 }}
                      onChange={() =>
                        this.onChangePerPage('150', currentLanguage)
                      }
                      checked={+perPage === 150}
                      groupName="perPage"
                      label="150"
                    />
                    <Radio
                      style={{ paddingRight: 15 }}
                      onChange={() =>
                        this.onChangePerPage('200', currentLanguage)
                      }
                      checked={+perPage === 200}
                      groupName="perPage"
                      label="200"
                    />
                  </div>
                </div>
              </Filter> */}
              {/* <div className="ac-divider-vertical" /> */}
              {console.log('queryqueryqueryquery1', query)}
              <Pagination
                currentPage={page}
                totalPage={totalPage}
                onChange={this.onChangePage}
                query={query}
                asPath={`/search-result/similar/${
                  data ? data.id : query.data_id
                }`}
                path="/similar"
              />
            </div>
          </div>
        </div>
        <div style={{ padding: 15, backgroundColor: '#FFFFFF' }}>
          <div className="container-fluid">
            {!loading && !error && collection.length === 0 && (
              <div style={{ padding: '15px 0' }} className="text-center">
                <h3
                  dangerouslySetInnerHTML={{
                    __html: t('photo_no_result_search_page'),
                  }}
                />
              </div>
            )}
            <div>
              {!loading && collection.length > 0 && (
                <>
                  {Config.isIllustAC() && (
                    <GalleryIllust
                      images={collection}
                      currentLang={currentLanguage}
                      lastRowHide={false}
                      prepareLoad={this.props.loading}
                      showImageActions
                      api={this.props.api}
                      hideSimilar={sameCreator}
                      toggleFilterSearch={false} //fake = true to reduce count image in row
                      isNotFullWidthCustom={false} // fake = true to reduce count image when not full 100vw
                    />
                  )}
                  {!Config.isIllustAC() && (
                    <Gallery
                      images={collection}
                      currentLang={currentLanguage}
                      lastRowHide={false}
                      colWidth={imageSize.width}
                      rowHeight={imageSize.height}
                      prepareLoad={this.props.loading}
                      showImageActions
                      api={this.props.api}
                      hideSimilar={sameCreator}
                    />
                  )}
                </>
              )}
            </div>
            <div className="pv">
              {loading && <LoadingSpinner style={{ padding: '20px 0' }} />}
              {collection.length > 0 && (
                <div className="navigator-footer pv50">
                  {!hasNext || loading ? (
                    <div />
                  ) : (
                    <div className="text-center">
                      <Link href={this.onNextLink()} disabled={!hasNext}>
                        <a
                          style={{
                            fontSize: 18,
                            padding: '10px 35px',
                          }}
                          className={`btn btn-ac-primary btn-${Config.serviceType}`}
                        >
                          {t('Next Page')}
                        </a>
                      </Link>
                    </div>
                  )}
                  <div
                    className={`pagination-wrapper ${
                      loading ? 'display-none' : ''
                    }`}
                  >
                    {console.log('queryqueryqueryquery1', query)}
                    <Pagination
                      currentPage={page}
                      totalPage={totalPage}
                      onChange={this.onChangePage}
                      query={query}
                      asPath={`/search-result/similar/${
                        data ? data.id : query.data_id
                      }`}
                      path="/similar"
                    />
                  </div>
                </div>
              )}
              <div className="clearfix" />
            </div>
            {Config.serviceType !== 'design_ac' && (
              <div
                className={`col-md-8 text-center col-md-offset-2 ${
                  collection.length ? 'md-ptb-150' : ''
                }`}
              >
                {collection && collection.length ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: t(Config.getPrefixContent('category_des'), {
                        number: totalItem,
                        keyword: (keywords || '').toLowerCase(),
                      }),
                    }}
                  />
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: t('change_param_message'),
                    }}
                  />
                )}
              </div>
            )}
            <div className="clearfix" />
          </div>
        </div>
        <style jsx>
          {`
            .search-result-page {
              margin-top: 48px;
            }
          `}
        </style>
        <style jsx global>
          {`
            .search-result-page .breadcrumb-wrapper {
              display: flex;
              padding: 5px 0;
            }
            .search-result-page .breadcrumb-wrapper .breadcrumb-left,
            .search-result-page .breadcrumb-wrapper .pagination-right {
              flex-basis: 0;
              flex-grow: 1;
              max-width: 100%;
              display: flex;
              align-items: center;
            }
            .search-result-page .breadcrumb-wrapper .pagination-right {
              justify-content: flex-end;
              padding-right: 15px;
            }

            .search-result-page .filter-item {
              display: flex;
              min-width: 350px;
            }

            .search-result-page .filter-title {
              flex-basis: 0;
              flex-grow: 1;
            }

            .search-result-page .filter-content {
              flex-basis: 0;
              flex-grow: 2;
              display: flex;
            }

            @media only screen and (max-width: 640px) {
              .search-result-page .breadcrumb-wrapper {
                display: block;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  currentLanguage: makeSelectCurrentLanguage(),
  similarPage: selectSimilar,
  patterns: makeSelectPatterns(),
});
const mapDispatchToProps = (dispatch) => ({
  loadSimilarData: (query) => dispatch(loadSimilarData(query)),
  changeOrder: (value) => dispatch(changeOrder(value)),
  changePerPage: (value) => dispatch(changePerPage(value)),
  changePage: (value) => dispatch(changePage(value)),
});
export default connect(mapStateToProps, mapDispatchToProps)(SimilarPage);
